import React from 'react';
import { IonIcon } from '@ionic/react';
import { rocketOutline } from 'ionicons/icons';

const ComingSoonBanner = ({ title }: { title: string }) => {
  return (
    <div className="relative h-full min-h-56 bg-background shadow-md dark:bg-background-accent border border-border rounded-xl overflow-hidden w-full">
      <svg
        viewBox="0 0 1154 258"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute -top-64 left-0 w-full h-[550px] opacity-25"
      >
        <path
          d="M1152.01 2.22656V309.933C1152.01 326.654 1145.63 341.792 1135.22 352.913C963.648 282.21 817.687 158.928 715.797 2.22656H1152.01Z"
          stroke="#0CD373"
          strokeWidth="0.886049"
          strokeMiterlimit="10"
        />
        <path
          d="M411.545 2.22656C313.636 153.257 174.845 273.22 11.7182 344.821C4.95165 334.808 0.988892 322.616 0.988892 309.431V2.22656H411.545Z"
          stroke="#0CD373"
          strokeWidth="0.886049"
          strokeMiterlimit="10"
        />
        <path
          d="M92.6309 2.22656H1056.7C952.271 163.305 775.383 269.288 574.706 269.288C374.028 269.288 197.066 163.305 92.6309 2.22656Z"
          stroke="#0CD373"
          strokeWidth="0.886049"
          strokeMiterlimit="10"
        />
      </svg>

      <div className="absolute top-0 left-0 flex flex-col items-center justify-center w-full h-full py-6 px-4 text-center">
        <div className=" inline-flex items-center gap-3 border border-border p-2 rounded-full mb-4 bg-background dark:bg-transparent">
          <IonIcon
            icon={rocketOutline}
            className={`text-text-dark-medium dark:text-text-light-medium text-base`}
          />
          <p className="text-sm text-text-dark-medium dark:text-text-light-medium font-semibold">
            Coming Soon
          </p>
          <IonIcon
            icon={rocketOutline}
            className={`text-text-dark-medium dark:text-text-light-medium text-base`}
          />
        </div>

        <h3 className="font-bold capitalize text-wrap text-text-dark-high dark:text-text-light-high mb-1">
          {title}
        </h3>

        <p className="text-text-dark-low dark:text-text-light-low mb-4 max-w-full">
          we are hard at work, to bring this feature to you.
        </p>
      </div>
    </div>
  );
};

export default ComingSoonBanner;
